module.exports = __webpack_public_path__ + "assets/pencil_icon@1x.25afc0d9.svg";